import React, { useState } from 'react';
import { CardFooter, Col, Row, Table, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TablePagination from './TablePagination';
import ComponentCard from './cards/ComponentCard';

function CommonTable({
  offset,
  title,
  onOffsetChange,
  data,
  headers,
  ordinal = false,
  rowComponent: RowComponent,
  rowComponentProps = {},
  pagination = true,
  partial = false,
  partialCount = 5,
  pageSize,
  onRowClick,
  hasRowPointer,
  rowIdPrefix,
  className,
}) {
  const [showMore, setShowMore] = useState(false);

  const handleClick = () => {
    setShowMore((prev) => !prev);
  };

  return (
    <Col xs={12}>
      <ComponentCard title={title}>
        <Row className="align-items-center">
          <Col xl={12}>
            <div className="table-responsive">
              <Table
                className={`table-centered table-custom table-sm table-nowrap table-hover mb-0 ${className || ''}`}
                striped
              >
                <thead className="align-middle thead-sm">
                  <tr className="text-uppercase fs-xxs">
                    {ordinal && <th className="text-center">#</th>}
                    {headers.map((header) => (
                      <th
                        key={header?.key ? header?.key : header?.label}
                        className={header.className}
                      >
                        {header.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {!isEmpty(data.items) &&
                    data.items.map((item, index) =>
                      !partial ||
                      showMore ||
                      (partial && !showMore && index < partialCount) ? (
                        <tr
                          id={rowIdPrefix ? `${rowIdPrefix}-${item.id}` : null}
                          key={item.id}
                          onClick={() => onRowClick?.(item)}
                          className={classNames(
                            hasRowPointer && 'common-table__row',
                            onRowClick && 'cursor-pointer',
                          )}
                        >
                          {ordinal && (
                            <td className="text-center">
                              {offset * pageSize + index + 1 || '-'}
                            </td>
                          )}
                          <RowComponent item={item} {...rowComponentProps} />
                        </tr>
                      ) : null,
                    )}
                  {isEmpty(data.items) && (
                    <tr>
                      <td colSpan={headers.length + (ordinal ? 1 : 0)}>
                        <span>No data</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Col>
          {pagination && !isEmpty(data.items) && (
            <CardFooter className="border-0">
              <TablePagination
                total={data.total}
                offset={offset}
                pageSize={pageSize}
                onOffsetChange={(offset) => onOffsetChange(offset)}
              />
            </CardFooter>
          )}

          {partial && (
            <Row>
              <Col md="12">
                <Button
                  className="mt-4 float-end rounded-pill btn-soft-primary"
                  type="button"
                  onClick={handleClick}
                >
                  {!showMore ? 'More' : 'Less'}
                </Button>
              </Col>
            </Row>
          )}
        </Row>
      </ComponentCard>
    </Col>
  );
}

CommonTable.defaultProps = {
  titleTranslated: false,
  offset: 0,
  onOffsetChange: () => {},
  title: '',
  pageSize: 50,
  onRowClick: () => {},
  hasRowPointer: true,
  rowIdPrefix: null,
};

CommonTable.propTypes = {
  rowIdPrefix: PropTypes.string,
  offset: PropTypes.number,
  title: PropTypes.string,
  onOffsetChange: PropTypes.func,
  data: PropTypes.object.isRequired,
  headers: PropTypes.array.isRequired,
  rowComponent: PropTypes.any.isRequired,
  titleTranslated: PropTypes.bool,
  pageSize: PropTypes.number,
  onRowClick: PropTypes.func,
  hasRowPointer: PropTypes.bool,
};

export default CommonTable;
